const validateEmail = (txt) => {
        return txt.length > 5 && txt.indexOf('@')>0;
  };



  export {validateEmail}